import request from '@/config/axios';

// 智能体 VO
export interface CozeBotsVO {
    description : string
    icon_url:string
    id:string
    is_published : boolean
    name:string
    owner_user_id:string
    published_at:Date
    updated_at:Date
}


// 智能体
export const CozeBotsApi = {
    // 分页
    getList: async (params: any) => {
        return await request.get({ url: `/ai/coze/v1/bots`, params });
    },
};
